// extracted by mini-css-extract-plugin
export default {"customFiltersCollapse":"FiltersLayoutV2_customFiltersCollapse__YWw+n"};